/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
export class RequestHelp_Util {
    /**
     * Returns a list of friends in sorted order for RequestHelp
     * @returns {Object} {off:Array<Object>, on:Array<Object>}
     */
    static async retrieveFriends() {
        let friendData;
        try {
            console.log("requesthelp");
            friendData = await OMT.friends.getFriendsList(true); // Get friends
            friendData.sort((a, b) => { // Sort alphabetically
                if (a.name > b.name) return 1;
                if (b.name > a.name) return -1;
                return 0;
            });
        } catch (error) {
            // Friend error!
            return { off: [], on: [] }; // Cuts out
        }

        const saveStateMgr = G.saveState;

        const offCooldownFriends = [];
        const onCooldownFriends = [];
        for (let i = 0; i < friendData.length; i++) {
            const cooldownTime = saveStateMgr.getUserCooldownRemaining('requestHelpData', friendData[i].id)

            if (cooldownTime === 0) { // Off cooldown
                offCooldownFriends.push(friendData[i]);
            } else { // on cooldown
                onCooldownFriends.push(friendData[i]);
            }
        }

        return {
            off: offCooldownFriends,
            on: onCooldownFriends,
        };
    }

    /**
     * Checks if friend is on cooldown and returns a status
     * @param {Object} potentialFriendSavedData
     * @param {Object} potentialFriendSavedData
     * @param {number} curTime
     * @return {Object} {status:number, data:Object}
     */
    static checkCooldown(potentialFriendSavedData, friendData, curTime) {
        let stat = 1; // On cooldown
        friendData.requestHelpData = potentialFriendSavedData; // Appends the FriendData savestate to the friend data package
        if (potentialFriendSavedData.duration === 0) {
            stat = 0;
        } else if (curTime - (potentialFriendSavedData.timeStart + potentialFriendSavedData.duration) >= 0) { // Check
            stat = 0; // Off cooldown
        }

        return {
            status: stat,
            data: friendData,
        };
    }

    /**
     * Rotates avatar appearance
     * @param {Phaser.Image} avatarA
     * @param {Phaser.Image} avatarB
     * @param {Phaser.Group} avatar
     * @param {Phaser.Texture} nextTexture
     */
    static changeAvatar(avatarA, avatarB, avatar, nextTexture, size = 80) {
        if (avatar.game) {
            avatarB.changeTexture(nextTexture); // Sets B to the next texture
            avatarB.width = avatarB.height = size; // Resize
            avatarB.alpha = 1; // Show
            avatar.addChild(avatarB); // Add behind avatarA of avatar group
            avatar.addChild(avatarA); // Add behind avatarA of avatar group
            const disappear = game.add.tween(avatarA) // AvatarA fades out, revealing B
                .to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In);

            disappear.onComplete.addOnce(() => {
                avatarA.changeTexture(nextTexture); // AvatarA changes immediately to B
                avatarA.width = avatarA.height = size;
                avatarA.alpha = 1; // AvatarA is showing now, but looks the same as B
                avatarB.alpha = 0; // AvatarB hides
            });

            disappear.start();
        }
    }

    /**
     * Copies the data from the json to avoid corrupting
     * @param {Array<Object>} prizeSection
     */
    static copyPrizeData(prizeSection) {
        const arr = [];
        for (let i = 0; i < prizeSection.length; i++) {
            const priz = prizeSection[i];
            const prizCopy = {
                prize: priz.prize,
                amount: priz.amount,
                chance: priz.chance,
            };
            arr.push(prizCopy);
        }
        return arr;
    }


    /**
     * Banner tweens in. Also used by Window_requestHelpMessage.js
     * @param {RequestHelp_Banner/Phaser.Group} banner
     */
    static enterTheBanner(banner) {
        banner.alpha = 0;
        banner.scale.x = 1.5;
        banner.scale.y = 0.5;
        banner.visible = true;
        const bannerEnter = game.add.tween(banner.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Sinusoidal.In); // 250 = requestHelp_Wheel.enterTheWheel().tweenTime/2
        const bannerEnter2 = game.add.tween(banner)
            .to({ alpha: 1 }, 250, Phaser.Easing.Sinusoidal.In);
        bannerEnter.start();
        bannerEnter2.start();
    }
}